import React, { useState, useEffect } from "react";
const EditCommentModal = ({ open, onClose, onUpdate, initialValue }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue, open]);

  if (!open) return null;

  return (
    <div className="edit-comment-overlay" onClick={onClose}>
      <div
        className="edit-comment-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h4>Edit</h4>

        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="// Add your Comments (Business Detail)"
        />

        <p className="edit-comment-hint">
          Tap on the card text to edit it anytime
        </p>

        <div className="edit-comment-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-update"
            onClick={() => {
              onUpdate(value);
              onClose();
            }}
          >
            Update
          </button>
        </div>
      </div>
        <style jsx>{`
        /* FULL SCREEN DARK OVERLAY */
.edit-comment-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* MODAL BOX */
.edit-comment-modal {
  background: #ffffff;
  width: 320px;
  max-width: 90%;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  animation: scaleIn 0.18s ease;
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* TITLE */
.edit-comment-modal h4 {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
}

/* TEXTAREA */
.edit-comment-modal textarea {
  width: 100%;
  height: 90px;
  resize: none;
  border-radius: 10px;
  padding: 10px;
  font-size: 14px;
  border: 2px solid #6c5ce7;
  outline: none;
}

/* HINT TEXT */
.edit-comment-hint {
  font-size: 12px;
  color: #777;
  margin-top: 6px;
}

/* ACTION BUTTONS */
.edit-comment-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.btn-cancel {
  background: transparent;
  border: none;
  color: #555;
  font-size: 14px;
  cursor: pointer;
}

.btn-update {
  background: #6c5ce7;
  color: white;
  border: none;
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

        `}</style>
    </div>
  );
};

export default EditCommentModal;
